import { render, staticRenderFns } from "./CustomerRelationshipInput.vue?vue&type=template&id=6dbe2809&scoped=true&"
import script from "./CustomerRelationshipInput.vue?vue&type=script&lang=js&"
export * from "./CustomerRelationshipInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe2809",
  null
  
)

export default component.exports